export default class CAHA1140RequestModel {}
